import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setEngravingDetails, setRootEngravingNames, setPopularBuildsList } from "../actions";

import engravingDetails from "./engravingDetails";
import popularBuilds from "./popularBuilds";
import { useTranslation } from "react-i18next";

export default function CurrentRoot() {

    const dispatch = useDispatch()
    const { t } = useTranslation()
    const languageRedux = useSelector(state => state.languageReducer)

    useEffect(() => {
        const engravingsList = t("ENGRAVINGS", { returnObjects: true })
        const statsList = t("STATS", { returnObjects: true })
        const buildNames = t("BUILD_NAMES", { returnObjects: true })
        dispatch(setEngravingDetails(engravingDetails(engravingsList)))
        dispatch(setRootEngravingNames(engravingsList))
        dispatch(setPopularBuildsList(popularBuilds(engravingsList, statsList, buildNames)))
    }, [])

    useEffect(() => {
        const engravingsList = t("ENGRAVINGS", { returnObjects: true })
        const statsList = t("STATS", { returnObjects: true })
        const buildNames = t("BUILD_NAMES", { returnObjects: true })
        dispatch(setEngravingDetails(engravingDetails(engravingsList)))
        dispatch(setRootEngravingNames(engravingsList))
        dispatch(setPopularBuildsList(popularBuilds(engravingsList, statsList, buildNames)))
    }, [languageRedux])

    // need to create a new piece of redux state to hold all of the finalized consumed engraving details
    // need to update that list in a useEffect hook every time language changes
    // need to create and run a set of functions in here which generates all of the desired data based on the current list of engraving names 
    // and sets that data to state

    return (
        <></>
    )
}